import { create } from 'zustand'
import { sucursalesSlice } from './slices/sucursalesSlice'
import { formularioPlatillosSlice } from './slices/formularioPlatillosSlice'

const usePlatillosStore = create((set,get) => ({
    error:null,
    isLoading: {cargarSucursalCategoria: true, cargarPlatillo: true},
    elNavigate:null,
    datos: {
        id:0,
        id_cp:"",
        nombre:"",
        descripcion:"",
        precio:"",
        nivel_picante:"0",
        tiempo:"",
        es_nuevo:false,
        estatus:1
    },
    sucursalesPlatillo: [],
    categoriasPlatillo: [],
    multiImagenes: [],
    imagenesOriginales: [],
    setError: (error) => set({ error }),
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    handleChangeImagen: (e) => set({ multiImagenes: e }),
    handleSucursales: (e) => set({ sucursalesPlatillo: e }),
    handleEsNuevo: (e) => set({ datos: { ...get().datos, es_nuevo: e } }),

    ...formularioPlatillosSlice(set,get),
    ...sucursalesSlice(set,get),
    iniciar: async() => {
        await get().obtenerSucursales();
        await get().obtenerCategoriaPlatillo();
        await get().obtenerPlatillo();
    },
    limpiar: () => {
      set({
        isLoading: {cargarSucursalCategoria: true, cargarPlatillo: true},
        elNavigate:null,
        datos: {
            id:0,
            id_cp:"",
            nombre:"",
            descripcion:"",
            precio:0,
            nivel_picante:"0",
            tiempo:0,
            es_nuevo:false,
            estatus:1
        },
        error:null,
        sucursalesPlatillo: [],
        categoriasPlatillo: [],
        multiImagenes: [],
        imagenesOriginales: []
      })
    }
}))
  
export default usePlatillosStore
